// dependencies
import { Map } from "immutable";

const lifeCycle = {
	start: "INIT",
	progress: "PROGRESS",
	success: "SUCCESS",
	fail: "FAIL",
};

export default Map(lifeCycle);
